import { ModelBase } from "@singularsystems/neo-core";

export default abstract class TemporalEntity extends ModelBase {

}